import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_4 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap lg:max-w-[60vw] text-ellipsis overflow-hidden" }
const _hoisted_5 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_7 = { class: "w-full px-6 border-t py-7" }

import { ref, watch, computed } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ViewButton from "@/components/buttons/ViewButton.vue";
import DataTable from "@/components/partials/DataTable.vue"; 
import SimplePagination from "@/components/partials/SimplePagination.vue";

import assignValues from "@/helpers/assignValues" 

import { useRouter, useRoute } from "vue-router";
import DataDictionaryService from "@/classes/Settings/DataDictionaryService";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";

import { filters, items } from "@/interfaces/pages/FilterPageInterface";
 
import { onIonViewWillEnter } from "@ionic/vue";
import { useNetworkStore } from "@/store/network";
import DataDictionaryOfflineProcessor from "@/classes/DataDictionary/Offline/processor/DataDictionaryOfflineProcessor";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

/**
 * VARIABLES
 */
// const items = ref<any>(null);
const filterSearch = ref<any>(route.query.query);
const page = ref<any>(route.query.page);
const lastPage = ref<any>(null);
const rows = ref<any>(route.query.rows);
const numRows = computed(() => (rows.value ? rows.value + " Rows" : "All"));
const headers: { text: string; haveSort?: boolean }[] = [{ text: "Name" }, { text: "Content" }];
const isLoaded = ref<boolean>(false);
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

/**
 * METHODS
 */
const getData = async (): Promise<any> => {
    const response = await DataDictionaryService.index(pickBy(filters.value), false, isNetworkAvailable.value);
    if (response?.status === 200 || response?.data != undefined) {
        const data = response.data;
        items.value = data.items;
        if (isNetworkAvailable.value) {
            await syncToOffline()
        }
        filters.value = assignValues(filters.value, data);
    } else {
        console.log(response);
    }
};

const applyFilters = (search: any = null) => {
	filters.value.query = search;
	getData();
};

const paginate = ({ page, rows }): void => {
	filters.value = Object.assign(filters.value, {
		page, rows
	})
	getData();
};

const syncToOffline = async () => {
    for (const index in items.value.data) {
        const item = items.value.data[index];
        await DataDictionaryOfflineProcessor.syncToOffline(item);
    }

}

/**
 * WATCHERS
 */
watch(
	filterSearch,
	throttle((val: string) => {
		applyFilters(val);
	}, 1000)
);

watch(
    () => isNetworkAvailable.value,
    async () => {
        await getData();
    }
);

onIonViewWillEnter(async () => {
    await getData();
    isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { pageTitle: "Data Dictionary" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SectionTitle, {
          title: "Data Dictionary",
          description: "Relevant data and other details"
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DataTable, {
            headers: headers,
            "no-action": false,
            count: _unref(items).total,
            hasSearch: true,
            search: filterSearch.value,
            "onUpdate:searchText": _cache[1] || (_cache[1] = (value) => (filterSearch.value = value)),
            searchPlaceholder: "Search dictionary",
            tableClass: "header-frm-table four dataDictionaryIndex_table"
          }, {
            body: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data, (item) => {
                return (_openBlock(), _createElementBlock("tr", { key: item }, [
                  _createElementVNode("td", _hoisted_3, _toDisplayString(item.name), 1),
                  _createElementVNode("td", _hoisted_4, _toDisplayString(item.content), 1),
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(ViewButton, {
                        onClick: ($event: any) => (_unref(router).replace(`/data-dictionary/${item.id}/view`))
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            tfoot: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(SimplePagination, {
                  numRows: _unref(filters).rows,
                  currentPage: _unref(items).current_page,
                  "last-page": _unref(items).last_page,
                  onUpdate: _cache[0] || (_cache[0] = (value) => paginate(value))
                }, null, 8, ["numRows", "currentPage", "last-page"])
              ])
            ]),
            _: 1
          }, 8, ["count", "search"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})